import { FC, useMemo, useState } from 'react';
import {
  renderChangePasswordView,
  renderProfilePictureView,
  renderSignatureView,
  renderViewProfileDetail,
} from './profileHelper';
import defaultImage from '../../assets/defaultImage.svg';
import { ViewProfileProps } from './profile.type';
import { validateAndDecodeAuthToken } from '../../utils/helper';
import { AuthTokenResponse } from '../../service/service.type';
import { UserType } from '@inplay/models';
import { useTranslation } from 'react-i18next';
import { LoginPlaceholder } from '../../utils/helper.type';
import ChangePasswordModal from './changePasswordModal';

const ViewProfile: FC<ViewProfileProps> = (props) => {
  const [showResetPasswordModal, setShowResetPasswordModal] =
    useState<boolean>(false);

  const userType: UserType | undefined = useMemo(() => {
    const validAuthToken: AuthTokenResponse | null =
      validateAndDecodeAuthToken();
    return validAuthToken?.type as UserType | undefined;
  }, []);
  const { i18n } = useTranslation();

  const loginTranslation: LoginPlaceholder =
    i18n.getResourceBundle(i18n.language, 'translation')?.login.placeholder ||
    {};

  const handleChangePassword = () => {
    setShowResetPasswordModal(true);
  };

  return (
    <>
      {props.userDetail?.profilePhoto &&
        renderProfilePictureView(props.userDetail.profilePhoto || defaultImage)}
      {props.userDetail?.signature &&
        renderSignatureView(props.userDetail.signature)}
      {renderViewProfileDetail(props.viewProfileDetail)}
      {userType !== UserType.VENUE_BRANCH_LOGIN &&
        userType !== UserType.VENUE_STAFF && (
          <>
            {renderChangePasswordView(handleChangePassword)}
            {showResetPasswordModal && (
              <ChangePasswordModal
                isOpen={showResetPasswordModal}
                onClose={() => setShowResetPasswordModal(false)}
                loginTranslation={loginTranslation}
              />
            )}
          </>
        )}
    </>
  );
};

export default ViewProfile;
